/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
/**
 * LogService - axios parameter creator
 * @export
 */
export const LogServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert alle Logfile Namen
         * @summary alle Serverlogs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLogfileNames: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/log/allLogfileNames`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert aktuellen Serverlog
         * @summary Serverlog
         * @param {number} [rows] Anzahl der Logzeilen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLog: async (rows?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (rows !== undefined) {
                localVarQueryParameter['rows'] = rows;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert Anzahl aktiver Sessions
         * @summary SessionCount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionCount: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/log/sessionCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogService - functional programming interface
 * @export
 */
export const LogServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LogServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert alle Logfile Namen
         * @summary alle Serverlogs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLogfileNames(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLogfileNames(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert aktuellen Serverlog
         * @summary Serverlog
         * @param {number} [rows] Anzahl der Logzeilen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLog(rows?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLog(rows, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert Anzahl aktiver Sessions
         * @summary SessionCount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionCount(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionCount(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LogService - factory interface
 * @export
 */
export const LogServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LogServiceFp(configuration)
    return {
        /**
         * Liefert alle Logfile Namen
         * @summary alle Serverlogs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLogfileNames(options?: any): AxiosPromise<string> {
            return localVarFp.getAllLogfileNames(options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert aktuellen Serverlog
         * @summary Serverlog
         * @param {number} [rows] Anzahl der Logzeilen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLog(rows?: number, options?: any): AxiosPromise<string> {
            return localVarFp.getLog(rows, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert Anzahl aktiver Sessions
         * @summary SessionCount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionCount(options?: any): AxiosPromise<string> {
            return localVarFp.getSessionCount(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LogService - interface
 * @export
 * @interface LogService
 */
export interface LogServiceInterface {
    /**
     * Liefert alle Logfile Namen
     * @summary alle Serverlogs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogServiceInterface
     */
    getAllLogfileNames(options?: any): AxiosPromise<string>;

    /**
     * Liefert aktuellen Serverlog
     * @summary Serverlog
     * @param {number} [rows] Anzahl der Logzeilen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogServiceInterface
     */
    getLog(rows?: number, options?: any): AxiosPromise<string>;

    /**
     * Liefert Anzahl aktiver Sessions
     * @summary SessionCount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogServiceInterface
     */
    getSessionCount(options?: any): AxiosPromise<string>;

}

/**
 * LogService - object-oriented interface
 * @export
 * @class LogService
 * @extends {BaseAPI}
 */
export class LogService extends BaseAPI implements LogServiceInterface {
    /**
     * Liefert alle Logfile Namen
     * @summary alle Serverlogs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogService
     */
    public getAllLogfileNames(options?: any) {
        return LogServiceFp(this.configuration).getAllLogfileNames(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert aktuellen Serverlog
     * @summary Serverlog
     * @param {number} [rows] Anzahl der Logzeilen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogService
     */
    public getLog(rows?: number, options?: any) {
        return LogServiceFp(this.configuration).getLog(rows, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert Anzahl aktiver Sessions
     * @summary SessionCount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogService
     */
    public getSessionCount(options?: any) {
        return LogServiceFp(this.configuration).getSessionCount(options).then((request) => request(this.axios, this.basePath));
    }
}
